import { AxiosError } from 'axios'

export const strings = {
  unauthorized: 'نام کاربری یا رمز اشتباه است',
  username: 'نام کاربری',
  usernameOrNatinalCode: 'نام کاربری یا کد ملی',
  password: 'رمز',
  currentPassword: 'رمز فعلی',
  newPassword: 'رمز جدید',
  otpCode: 'یکبار رمز',
  sendOtp: 'ارسال یکبار رمز',
  role: 'نقش',
  fullname: 'نام کامل',
  nationalCode: 'کد ملی',
  phoneNumber: 'شماره موبایل',
  email: 'ایمیل',
  legalEntity: 'شرکت/سازمان',
  state: 'استان',
  city: 'شهر',
  groupName: 'گروه',
  groups: 'گروه ها',
  userGroups: 'گروه کاربر',
  mountpointGroups: 'گروه ایستگاه',
  accountInfo: 'اطلاعات کاربری',
  personalInfo: 'اطلاعات فردی',

  apply: 'اعمال',
  delete: 'حذف',
  changePassword: 'تغییر رمز',
  applying: 'در حال اعمال',
  done: 'انجام شد',
  yes: 'بلی',
  no: 'خیر',
  cancel: 'لغو',
  youSure: 'آیا مطمئن هستید؟',

  regular: 'معمولی',
  operator: 'اپراتور',
  admin: 'ادمین',
  error: 'خطا',
  mountpoint: 'ایستگاه',
  mainFields: 'فیلد های اصلی',
  supplementaryFields: 'فیلد های تکمیلی',
  name: 'نام',
  latitude: 'عرض جغرافیایی',
  longitude: 'طول جغرافیایی',
  mountpointSource: 'منبع تصحیحات',
  mountpointSourceServer: 'ایستگاه ثابت',
  mountpointSourceNearest: 'نزدیک ترین',
  mountpointSourceExternal: 'کستر خارجی',
  creation: 'ایجاد',
  search: 'جستجو',
  notExists: 'وجود ندارد',
  search_create: 'جستجو / ایجاد',
  connectedTo: 'متصل به',
  sourceAgent: 'عامل منبع',
  IPAddr: 'آدرس آی پی',
  userAgent: 'مدل دستگاه',
  connectedTime: 'مدت اتصال',
  disconnectedTime: 'مدت قطعی',
  seconds: 'ثانیه',
  empty: 'خالی',
  mountpointChartTitle: 'تعداد پیغام های تصحیحات',
  rtcmCount: 'تعداد RTCM',
  today: 'امروز',
  day: 'روز',
  week: 'هفته',
  month: 'ماه',
  allTime: 'کل',
  optional: 'اختیاری',
  captcha: 'کد امنیتی',
  confirmationCode: 'کد تایید',
  sourceType: 'نوع منبع',
  serverPassword: 'رمز سرور',
  sourceNearestNames: 'نام ایستگاه ها',
  sourceExternalAddr: 'آدرس کستر',
  sourceExternalUsername: 'نام کاربری کستر',
  sourceExternalPassword: 'رمز کستر',
  sourceExternalMountpoint: 'ایستگاه خارجی',
  identifier: 'نام منطقه',
  format: 'فرمت داده',
  formatDetails: 'محتوای داده',
  carrier: 'نوع سیگنال',
  navigationSystem: 'نوع سیستم',
  network: 'نام شبکه',
  country: 'کشور',
  nmea: 'نیاز به NMEA',
  solution: 'نوع تصحیحات',
  generator: 'تولید کننده تصحیحات',
  compressionEncryption: 'نوع رمزنگاری',
  authentication: 'احراز حویت',
  fee: 'هزینه',
  bitRate: 'نرخ بیت',
  miscellaneous: 'متفرقه',
  disconnected: 'قطع',
  optimal: 'مطلوب',
  acceptable: 'قابل قبول',
  weak: 'ضعیف',
  veryWeak: 'خیلی ضعیف',
  connected: 'متصل',
  disconnect: 'قطعی',
  showDisconnects: 'نمایش قطعی ها',
  yourTime: 'زمان شما',
  serverTime: 'زمان سرور',
  invalidTimeError:
    'زمان سیستم شما به درستی تنظیم نشده است و ممکن است برخی از اطلاعات به درستی نمایش داده نشود، لطفا برای استفاده بهتر از پنل زمان سیستم خود را به درستی تنظیم نمایید.',
  difference: 'اختلاف',
  goInPanel: 'ورود به پنل',
  noUserGroupMeansInactive:
    'کاربران بدون گروه غیر فعال هستند چون به هیچ چیزی دسترسی ندارند',
  active: 'فعال',
  inactive: 'غیر فعال',
  field: 'فیلد',
  fieldFilter: 'فیلتر فیلد',
  forgotPasswordChangeError: `در تغییر رمز خطایی پیش آمد، لطفا دوباره سعی کنید:`,
  deleteGroup: 'حذف گروه',
  renameGroup: 'تغییر نام گروه',
  distanceTool: 'ابزار فاصله',
  after: 'بعد از زمان',
  rowCount: 'تعداد سطر',
  serverFilter: 'فیلتر سرور',
  do: 'انجام',
  stationSettigns: 'تنظیمات ایستگاه',
  liveSignalsQualityGraph: 'گراف کیفیت لحظه ای سیگنال ها',
  satellitesCountGraph: 'گراف تعداد ماهواره ها',
  signalsQualityChangesGraph: 'گراف تغییرات کیفیت سیگنال ها',
  messagesCountGraph: 'گراف تعداد پیغام ها',
  from: 'از',
  to: 'تا',
  date: 'تاریخ',
  startDate: 'تاریخ شروع',
  endDate: 'تاریخ پایان',
  calendar: 'تقویم',
  perisanCalendar: 'شمسی',
  gregorianCalendar: 'میلادی',
  minute: 'دقیقه',
  hour: 'ساعت',
  averageRange: 'بازه متوسط گیری',
  unit: 'واحد',
  system: 'سیستم',
  displayGraph: 'نمایش گراف',
  distance: 'فاصله',
  dateRangeHelper: 'تاریخ شروع نمی تواند بزرگتر از تاریخ پایان باشد. ',
  users: 'کاربران',
  userSettings: 'تنظیمات کاربر',
  userStatus: 'وضعیت کاربر',
  mountpoints: 'ایستگاه ها',
  linksStabilityStatus: 'وضعیت پایداری لینک ها',
  groupsPermission: 'دسترسی گروه ها',
  measure: 'اندازه گیری فاصله',
  systemLog: 'لاگ سیستم',
  rinexService: 'سرویس راینکس',
  rinexRequest: 'درخواست راینکس',
  requestNewRinex: 'درخواست جدید راینکس',
  rinexRequestsList: 'لیست درخواست های راینکس',
  station: 'ایستگاه',
  startTime: 'ساعت شروع',
  endTime: 'ساعت پایان',
  range: 'بازه',
  dataRate: 'نرخ داده',
  rinexVersion: 'نسخه راینکس',
  applyRequest: 'ثبت درخواست',
  helperText: 'را وارد نمایید',
  selectHelperText: 'را انتخاب نمایید',
  projectName: 'نام پروژه',
  status: 'وضعیت',
  readyToDownload: 'آماده دانلود',
  processing: 'در حال پردازش',
  dataNotFound: 'داده ای یافت نشد!',
  systems: 'منظومه ها',
  unstable: 'ناپایدار',
  userHistory: 'تاریخچه کاربر',
  atLeastSelectOne: 'حداقل یک مورد را انتخاب نمایید',
  local: 'محلی',
  worldwide: 'جهانی',
  defaultName: 'نام پیش فرض',
  passwordMinLengthHelper: 'رمز عبور باید حداقل 8 کاراکتر باشد!',
  passwordFormatHelper:
    'رمز عبور میبایست متشکل از حروف بزرگ و کوچک انگلیسی، اعداد و علامت ها باشد!',
  withoutConnection: 'بدون ارتباط',
  yesterday: 'دیروز',
  dayBefore: 'روز پیش',
  altitude: 'ارتفاع',
  base: 'مرجع',
  confirmPosition: 'تایید موقعیت مرجع',
  coordinateDifference: 'اختلاف مختصات',
  useBasePosition: 'استفاده از موقعیت مرجع',
  start: 'شروع',
  end: 'پایان',
  logsList: 'لیست لاگ ها',
  diconnectionsList: 'لیست قطعی ها',
  proxy: 'پروکسی',

  mapAxiosError: (err: AxiosError): AxiosError => {
    if (!err.response) {
      err.message = 'پاسخی دریافت نشد'
      return err
    }

    if (err.response.status === 500) {
      err.message = 'خطای سرور'
      return err
    }

    if (err.response.status === 403) {
      err.message = 'خطای دسترسی'
      return err
    }

    if (err.response.status === 429) {
      err.message = 'تعداد درخواست بیش از حد مجاز'
      return err
    }

    let errCode: number
    try {
      errCode = parseInt(err.response.data.split('\n')[0].split(':')[1])
    } catch (e) {
      err.message = 'خطای ناشناخته'
      return err
    }

    switch (errCode) {
      case -1:
        err.message = 'مشکلی در اجرای درخواست پیش آمد'
        return err
      case 1:
        err.message = 'محتوی درخواست نادرست است'
        return err
      case 2:
        err.message = 'کد یکبار مصرف اشتباه است'
        return err
      case 3:
        err.message = 'نام کاربری قابل قبول نیست'
        return err
      case 4:
        err.message = 'نقش کاربر اشتباه است'
        return err
      case 5:
        err.message = 'کد ملی اشتباه است'
        return err
      case 6:
        err.message = 'رمز عبور قابل قبول نیست'
        return err
      case 7:
        err.message = 'نام کاربری وجود دارد'
        return err
      case 8:
        err.message = 'رمز عبور قبلا استفاده شده است'
        return err
      case 9:
        err.message = 'نام کاربری/رمز عبور اشتباه است'
        return err
      case 10:
        err.message = 'نام گروه قابل قبول نیست'
        return err
      case 11:
        err.message = 'نام مانت پوینت قابل قبول نیست'
        return err
      case 12:
        err.message = 'نوع منبع داده اشتباه است'
        return err
      case 13:
        err.message = 'کد امنیتی اشتباه است'
        return err
      default:
        err.message = 'خطای ناشناخته'
        return err
    }
  },
}
